<template>
    <v-app>

      <Drawer current_item="menu_station"></Drawer>

      <v-dialog v-model="dialog_add_station" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{ $t('add_station') }}</v-card-title>
          <v-card-text>
            <div class="subtitle-2 mt-6" align="left"><b>{{ $t('station_name') }}</b></div>
            <v-text-field v-model="new_station_name" outlined class="mt-1"></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="addStation">{{ $t('form_submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog_action_confirm"
        persistent
        scrollable
        max-width="600"
      >
          <v-card>
              <v-card-title>
                  กรุณายืนยันที่จะลบจุดบริการ {{ del_station.station_name }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialog_action_confirm=false"
                >
                  ยกเลิก
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialog_action_confirm=false;delStation();"
                >
                  ยืนยัน
                </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>

      <v-main class="ml-6 mr-6">

          <v-row align="end" justify="space-between">
          <v-col cols="12" md="8" class="text-md-h4 text-h5" align="left">
              {{ $t('Station_List_Title') }}
              </v-col>
          <v-col cols="12" md="4" align="left">
              <v-btn v-if="permission.includes('CREATE_station_list')" tile color="success" @click="dialog_add_station = true">
                  <v-icon left>mdi-plus</v-icon>{{ $t('add_station') }}
              </v-btn>
          </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-card
              class="mx-auto mt-4 mr-6"
              outlined
              elevation=8
          >
              <v-simple-table fixed-header align="left" >
                  <template v-slot:default>
                  <thead>
                      <tr>
                      <th class="text-left">#{{ $t('station_code') }}</th>
                      <th class="text-left">{{ $t('station_name') }}</th>
                      <th></th>
                      </tr>
                  </thead>
                  <tbody >
                      <tr v-for="item in station_list" :key="item.name">
                          <td><a :href="'station/' + item.station_code">{{ item.station_code }}</a></td>
                          <td><a :href="'station/' + item.station_code">{{ item.station_name }}</a></td>
                          <td v-if="permission.includes('DELETE_station_list')">
                              <v-btn tile icon @click="dialogDelStation(item)">
                              <v-icon>mdi-trash-can</v-icon>
                              </v-btn>
                          </td>
                      </tr>
                  </tbody>
                  </template>
              </v-simple-table>
          </v-card>
      </v-main>
    </v-app>
</template>

<style>
table tr td a {
    display:block;
    width:100%;
    text-decoration:none;
    color:inherit;
}
table tr td a:link {
  color:inherit;
}
table tr td a:visited {
  color:inherit;
}
table tr:hover {
    cursor: pointer;
}

</style>

<script>
import Drawer from '@/components/Drawer.vue'

import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

export default {
  components: {
    Drawer
  },
  data () {
    return {
      station_list : []
      ,items_station: []
      ,dialog_add_station : false
      ,new_station_name : ""
      ,permission : []
      ,dialog_action_confirm : false
      ,del_station : {station_name:""}
    }
  },
  mounted : function () {
    var que = this.$store.commit('addLoading')
    this.permission = Staff.getPermission('Station').then(permission=>{
        this.permission = permission
        this.$store.commit('finishLoading',que)
    })
    this.reload()
  },
  methods : {
    reload(){
      this.$store.getters.getStationList
      .then(result=>{
        this.station_list = result
      }).catch(error => {
        this.$router.push({name:'Error',params:error}) 
      })
    },
    addStation(){
      this.dialog_add_station = false
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.manage.station.add_station,{station_name:this.new_station_name},{ headers: Staff.getTokenHeader()})
      .then(() => {
        this.$store.commit('finishLoading',que)
        this.new_station_name = ""
        this.$store.commit('resetStationList')
        this.reload()
      }).catch(error => {
        this.$router.push({ name: 'Error' ,params:error}) 
      })

    },
    dialogDelStation(station){
        this.dialog_action_confirm = true
        this.del_station = station
    },
    delStation(){
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.manage.station.del_station,{station_code:this.del_station.station_code},{ headers: Staff.getTokenHeader()})
      .then(() => {
        this.$store.commit('finishLoading',que)
        this.$store.commit('resetStationList')
        this.reload()
      }).catch(error => {
        this.$router.push({ name: 'Error' ,params:error}) 
      })
    },
  }
}
</script>